/**
 * 群聊通用提示类型
 */
export const GROUP_CHAT_UNIVERSAL_TIP_TYPES = {
  /**
   * 申请加入群聊
   */
  apply_join: 'apply_join',
  /**
   * 撤回
   */
  withdrawal: 'withdrawal',
  /**
   * 通知设置
   */
  notify_setting: 'notify_setting',
  /**
   * 禁言用户
   */
  ban_user: 'ban_user',
  /**
   * 未知
   */
  unknown: 'unknown',
};

/**
 * 群聊通用提示交互
 */
export const GROUP_CHAT_UNIVERSAL_TIP_ACTIONS = {
  /**
   * 用户资料
   */
  user_profile: 'user_profile',
  /**
   * 群聊设置
   */
  chat_group_setting: 'chat_group_setting',
  /**
   * 查看详情
   */
  notify_setting: 'notify_setting',
  /**
   * 申请加入群聊
   */
  chat_group_approval: 'chat_group_approval',
  /**
   * 未知
   */
  unknown: 'unknown',
};
